import { render, staticRenderFns } from "./pivots.component.vue?vue&type=template&id=08d0e7bf&scoped=true"
import script from "./pivots.component.vue?vue&type=script&lang=ts"
export * from "./pivots.component.vue?vue&type=script&lang=ts"
import style0 from "./pivots.component.vue?vue&type=style&index=0&id=08d0e7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0e7bf",
  null
  
)

export default component.exports